import { createAction, props } from '@ngrx/store';
import { DealerStatus, ReviewStatus } from 'src/app/public/account/constants/dealer-basic-data';
import { ContractModification } from 'src/app/public/account/models/contract-modification.model';
import { Contract } from 'src/app/public/account/models/contract.model';
import { DealerCriteria } from 'src/app/public/account/models/dealer-criteria.model';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { ReviewReply } from 'src/app/public/account/models/review-reply.model';
import { Review } from 'src/app/public/account/models/review.model';
import { CarStatus, CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { Alert } from 'src/app/public/car/models/alert.model';
import { CarCriteria } from 'src/app/public/car/models/car-criteria.model';
import { Car } from 'src/app/public/car/models/car.model';
import { TransactionRole, TransactionStage, ObjectClass, ServiceType } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { MenuCode } from 'src/app/public/common/constants/session-basic-data';
import { Price, Offer } from 'src/app/public/common/models/string-data.model';
import { JobCriteria } from 'src/app/public/keep/models/job-criteria.model';
import { KeepOffer } from 'src/app/public/keep/models/keep-offer.model';

export class DealerActions {

    //fetch and update dealer profile

    public static fetchMyDealerProfileSubmit = createAction(
        '[Dealer API ] fetch My Profile Submit'
    );

    public static fetchMyDealerProfileSuccess = createAction(
        '[Dealer API ] fetch My Profile Success',
        props <{ dealer: Dealer }> ()
    );

    public static updateDealerProfileSubmit = createAction(
        '[Dealer Form Component] Update Dealer Form Submit',
        props <{ dlUpdates: Dealer }> ()
    );

    public static updateDealerProfileSuccess = createAction(
        '[Dealer API] Update Dealer Profile Success',
        props <{ dealer: Dealer }> ()
    );

    public static fetchProviderPublicDetailsSubmit = createAction(
        '[Provider Details Form] fetch Provider Public Details Component',
        props <{ providerId: string }> ()
    );

    public static fetchProviderPublicDetailsSuccess = createAction(
        '[Search API] fetch Provider Public Details Success',
        props <{ provider: Dealer }> ()
    );

    public static toggleFavoriteProviderSubmit = createAction(
        '[Provider Details Form] toggle fav provider submit',
        props <{ providerId: string, makeFav: boolean }> ()
    );

    public static toggleFavoriteProviderSuccess = createAction(
        '[Search API] toggle fav provider Success',
        props <{ providerId: string, makeFav: boolean }> ()
    );

    // dealer status
    public static dealerStatusUpdateSubmit = createAction(
        '[Dealer API] Update dealer status submit',
        props <{ dealerId: string, status: DealerStatus }> ()
    );

    public static dealerStatusUpdateSuccess = createAction(
        '[Dealer API] Update dealer status success',
        props <{ dealerId: string, status: DealerStatus }> ()
    );


    // My park

    public static fetchOwnerParkSubmit = createAction(
        '[My Park Component] Fetch Owner Park Submit',
        props <{ carCriteria: CarCriteria }> ()
    );

    public static fetchProviderParkSubmit = createAction(
        '[My Park Component] Fetch Provider Park Submit'
    );

    public static fetchParkSuccess = createAction(
        '[Dealer API] fetch Car park Success',
        props <{ cars: Car[] }> ()
    );

    
    // Customer cars

    public static fetchCustomerCarsSubmit = createAction(
        '[My Basket Component] Fetch customer cars submit',
        props <{ businessLine: CarBusinessLine, favoritesOnly: boolean }> ()
    );

    public static fetchCustomerCarsSuccess = createAction(
        '[Dealer API] Fetch customer cars success',
        props <{ businessLine: CarBusinessLine, cars: Car[] }> ()
    );

    // Provider cars

    public static fetchProviderCarsSubmit = createAction(
        '[My Basket Component] Fetch provider cars submit',
        props <{ businessLine: CarBusinessLine }> ()
    );

    public static fetchProviderCarsSuccess = createAction(
        '[Dealer API] Fetch provider cars success',
        props <{ businessLine: CarBusinessLine, cars: Car[] }> ()
    );

    // Admin basket

    public static fetchAdminCarBasketSubmit = createAction(
        '[Admin Basket Component] Fetch admin basket cars submit',
        props <{ businessLine: CarBusinessLine }> ()
    );

    public static fetchAdminCarBasketSuccess = createAction(
        '[Dealer API] Fetch admin basket cars success',
        props <{ businessLine: CarBusinessLine, cars: Car[] }> ()
    );



    //Create, update and delete cars

    public static createNewCarSubmit = createAction(
        '[CarForm Component] New Car Form Submit',
        props <{ car: Car }> ()
    );

    public static updateCarSubmit = createAction(
        '[CarForm Component] Edit Car Form Submit',
        props <{ carUpdates: Car }> ()
    );

    public static deleteCarSubmit = createAction(
        '[Car Card] Delete Car Submit',
        props <{ carId: string }> ()
    );

    public static createNewCarSuccess = createAction(
        '[Car API] Create New Car Success',
        props <{ car: Car }> ()
    );

    public static updateCarSuccess = createAction(
        '[Car API] Edit Car Success',
        props <{ car: Car }> ()
    );

    public static deleteCarSuccess = createAction(
        '[Car API] Delete Success',
        props <{ carId: string }> ()
    );

    
    // car status
    public static updateCarStatusSubmit = createAction(
        '[Dealer API] Update car status submit',
        props <{ carId: string, status: string }> ()
    );

    public static updateCarStatusSuccess = createAction(
        '[Dealer API] Update car status success',
        props <{ carId: string, status: CarStatus }> ()
    );

    // ProviderOffer 
    public static providerOfferNewSubmit = createAction(
        '[Car Component] providerOffer New Submit',
        props <{ providerOffer: Car, objectSource: ObjectSource }> ()
    );

    public static providerOfferUpdateSubmit = createAction(
        '[Car Component] providerOffer Update Submit',
        props <{ providerOffer: Car, objectSource: ObjectSource }> ()
    );

    public static providerOfferUpsertSuccess = createAction(
        '[Car Component] providerOffer Update Success',
        props <{ providerOffer: Car, objectSource: ObjectSource }> ()
    );

    public static providerOfferTogglePostedSubmit = createAction(
        '[Car API] Update providerOffer posted status submit',
        props <{ carId: string, providerOfferId: string, businessLine: CarBusinessLine, objectSource: ObjectSource }> ()
    );

    public static providerOfferToggleClosedSubmit = createAction(
        '[Car API] Update providerOffer closed status submit',
        props <{ carId: string, providerOfferId: string, businessLine: CarBusinessLine, objectSource: ObjectSource }> ()
    );

    public static providerOfferDeleteSubmit = createAction(
        '[SearchCriteria Component] providerOffer Remove Submit',
        props <{ carId: string, providerOfferId: string, businessLine: CarBusinessLine, objectSource: ObjectSource }> ()
    );

    public static providerOfferDeleteSuccess = createAction(
        '[SearchCriteria Component] providerOffer Remove Success',
        props <{ carId: string, providerOfferId: string, businessLine: CarBusinessLine, objectSource: ObjectSource }> ()
    );

    public static providerOffersFetchMySubmit = createAction(
        '[SearchCriteria Component] Fetch my providerOffers  Submit',
        props <{ transactionRole: TransactionRole, businessLine: CarBusinessLine, transactionStages: TransactionStage [] }> ()
    );

    public static providerOffersFetchMySuccess = createAction(
        '[SearchCriteria Component] Fetch my providerOffers Success',
        props <{ providerOffers: Car [], businessLine: CarBusinessLine }> ()
    );



    // KeepOffer 
    public static keepOfferNewSubmit = createAction(
        '[Car Component] keepOffer New Submit',
        props <{ keepOffer: KeepOffer, objectSource: ObjectSource }> ()
    );

    public static keepOfferUpdateSubmit = createAction(
        '[Car Component] keepOffer Update Submit',
        props <{ keepOffer: KeepOffer, objectSource: ObjectSource }> ()
    );

    public static keepOfferUpsertSuccess = createAction(
        '[Car Component] keepOffer Update Success',
        props <{ keepOffer: KeepOffer, objectSource: ObjectSource }> ()
    );

    public static keepOfferTogglePostedSubmit = createAction(
        '[Car API] Update keepOffer posted status submit',
        props <{ keepOfferId: string, objectSource: ObjectSource }> ()
    );

    public static keepOfferToggleClosedSubmit = createAction(
        '[Car API] Update keepOffer closed status submit',
        props <{ keepOfferId: string, objectSource: ObjectSource }> ()
    );

    public static keepOfferDeleteSubmit = createAction(
        '[SearchCriteria Component] keepOffer Remove Submit',
        props <{ keepOfferId: string, objectSource: ObjectSource }> ()
    );

    public static keepOfferDeleteSuccess = createAction(
        '[SearchCriteria Component] keepOffer Remove Success',
        props <{ keepOfferId: string, objectSource: ObjectSource }> ()
    );

    public static keepOffersFetchMySubmit = createAction(
        '[SearchCriteria Component] Fetch my keepOffers  Submit',
        props <{ transactionRole: TransactionRole, transactionStages: TransactionStage [] }> ()
    );

    public static keepOffersFetchMySuccess = createAction(
        '[SearchCriteria Component] Fetch my keepOffers Success',
        props <{ keepOffers: KeepOffer [] }> ()
    );



    // Toggle car business line

    public static toggleCarBusinessLineStatusSubmit = createAction(
        '[Car Card] Toggle car business line status Submit',
        props <{ carId: string, status: boolean, businessLine: CarBusinessLine }> ()
    );

    public static toggleCarBusinessLineStatusSuccess = createAction(
        '[Car API] Toggle car business line status Success',
        props <{ carId: string, status: boolean, businessLine: CarBusinessLine}> ()
    );

     //Togle favorite

    public static toggleFavoriteSubmitOld = createAction(
        '[Car Card] Toggle Favorite Submit',
        props <{ car: Car, makeFav: boolean, businessLine: CarBusinessLine }> ()
    );

    public static toggleFavoriteSubmit = createAction(
        '[Car Card] Toggle Favorite Submit',
        props <{ objectId: string, objectClass: ObjectClass, makeFav: boolean, businessLine: CarBusinessLine }> ()
    );

    public static toggleFavoriteSuccessOld = createAction(
        '[Car API] Toggle Favorite Success',
        props <{ car: Car, makeFav: boolean, businessLine: CarBusinessLine}> ()
    );

    public static toggleFavoriteSuccess = createAction(
        '[Car API] Toggle Favorite Success',
        props <{ objectId: string, objectClass: ObjectClass, makeFav: boolean, businessLine: CarBusinessLine}> ()
    );

    
    //Alerts

    public static addNewAlertSubmit = createAction(
        '[SearchCriteria Component] Alert Save Submit',
        props <{ criteria: CarCriteria | DealerCriteria | JobCriteria }> ()
    );

    public static addNewAlertSubmit_o = createAction(
        '[SearchCriteria Component] Alert Save Submit',
        props <{ criteria: CarCriteria }> ()
    );

    public static addNewAlertSuccess = createAction(
        '[SearchCriteria Component] Alert Save Success',
        props <{ alert: Alert }> ()
    );

    public static fetchMyAlertsSubmit = createAction(
        '[SearchCriteria Component] Fetch my Alerts  Submit',
        props <{ businessLine: CarBusinessLine, dealerId: string }> ()
    );

    public static fetchMyAlertsSuccess = createAction(
        '[SearchCriteria Component] Fetch my Alerts Success',
        props <{ alerts: Alert [] }> ()
    );

    public static alertUpdateCriteriaSubmit = createAction(
        '[SearchCriteria Component] Alert Update Criteria Submit',
        props <{ alertId: number, carCriteria: CarCriteria }> ()
    );

    public static alertUpdateStatusSubmit = createAction(
        '[SearchCriteria Component] Alert Update Status Submit',
        props <{ businessLine: CarBusinessLine, alertId: number, status: boolean}> ()
    );

    public static alertUpdateSuccess = createAction(
        '[SearchCriteria Component] Alert Update Success',
        props <{ alert: Alert }> ()
    );

    public static alertDeleteSubmit = createAction(
        '[SearchCriteria Component] Alert Remove Submit',
        props <{ businessLine: CarBusinessLine, alertId: number }> ()
    );

    public static alertDeleteSuccess = createAction(
        '[SearchCriteria Component] Alert Remove Success',
        props <{ businessLine: CarBusinessLine, alertId: number }> ()
    );


    
    //Prices and offers

    public static createNewCarPriceSubmit = createAction(
        '[MyPark Component] Create New Car Price Submit',
        props <{ carId: string, businessLine: CarBusinessLine, price: Price }> ()
    );

    public static createNewCarOfferSubmit = createAction(
        '[MyPark Component] Create New Car Offer Submit',
        props <{ carId: string, amount: number }> ()
    );

    public static createNewCarPriceSuccess = createAction(
        '[Dealer API] Create New Car Price Success',
        props <{ carId: string, businessLine: CarBusinessLine, price: Price }> ()
    );

    public static createNewCarOfferSuccess = createAction(
        '[Dealer API] Create New Car Offer Success',
        props <{ carId: string, offer: Offer }> ()
    );

    //reviews

    public static reviewAddSubmit = createAction(
        '[Dealer API] Add new Review submit',
        props <{ review: Review }> ()
    );

    public static reviewAddSuccess = createAction(
        '[Dealer API] Add new Review success',
        props <{ review: Review }> ()
    );

    public static reviewStatusUpdateSubmit = createAction(
        '[Dealer API] Review status update submit',
        props <{ reviewId: string, status: ReviewStatus }> ()
    );

    public static reviewStatusUpdateSuccess = createAction(
        '[Dealer API] Review status updatesuccess',
        props <{ review: Review }> ()
    );

    public static reviewReplySubmit = createAction(
        '[Dealer API] Reply Review submit',
        props <{ reviewId: string, reply: ReviewReply }> ()
    );

    public static reviewReplySuccess = createAction(
        '[Dealer API] Reply Review success',
        props <{ reviewId: string, reply: ReviewReply }> ()
    );

    public static reviewReplyStatusUpdateSubmit = createAction(
        '[Dealer API] Review reply status update submit',
        props <{ reviewId: string, replyIndex: number, status: ReviewStatus  }> ()
    );

    public static reviewReplyStatusUpdateSuccess = createAction(
        '[Dealer API] Review reply status updatesuccess',
        props <{ reviewId: string, replyIndex: number, reply: ReviewReply }> ()
    );

    //my providers

    public static newFavoriteProviderSubmit = createAction(
        '[Dealer API] Add new Provider submit',
        props <{ providerId: string, adding: boolean }> ()
    );

    public static newFavoriteProviderSuccess = createAction(
        '[Dealer API] Add new Provider success',
        props <{ providerId: string, adding: boolean }> ()
    );

    public static fetchMyProvidersSubmit = createAction(
        '[Dealer Component] Fetch my providers submit'
    );

    public static fetchMyProvidersSuccess = createAction(
        '[Dealer API] Fetch my providers success',
        props <{ providers: Dealer[] }> ()
    );

    public static fetchMyOwnersSubmit = createAction(
        '[Dealer Component] Fetch my owners submit'
    );

    public static fetchMyOwnersSuccess = createAction(
        '[Dealer API] Fetch my owners success',
        props <{ owners: Dealer[] }> ()
    );

    //car providers

    public static updateCarProviderSubmit = createAction(
        '[Dealer API] Update car Provider submit',
        props <{ carId: string, providerId: string }> ()
    );

    // public static updateCarProviderSuccess = createAction(
    //     '[Dealer API] Update car Provider success',
    //     props <{ carId: string, providerId: string }> ()
    // );

    public static updateCarProviderActiveSubmit = createAction(
        '[Dealer API] Update car Provider active submit',
        props <{ carId: string, providerActive: boolean }> ()
    );

    // public static updateCarProviderActiveSuccess = createAction(
    //     '[Dealer API] Update car Provider active success',
    //     props <{ carId: string, providerActive: boolean }> ()
    // );



    // provided services

    public static newProvidedServiceSubmit = createAction(
        '[Dealer API] Add new Provided service submit',
        props <{ service: ServiceType, adding: boolean }> ()
    );

    public static newProvidedServiceSuccess = createAction(
        '[Dealer API] Add new Provided service success',
        props <{ service: ServiceType, adding: boolean }> ()
    );

    // contract

    public static contractNewSubmit = createAction(
        '[Component] Add new contract submit',
        props <{ contract: Contract, objectSource: ObjectSource  }> ()
    );
    /*
    public static contractNewSuccess = createAction(
        '[Dealer API] Add new contract success',
        props <{ contract: Contract }> ()
    );
    */
    public static contractUpdateSubmit = createAction(
        '[Component] Update contract submit',
        props <{ contract: Contract, objectSource: ObjectSource }> ()
    );

    public static contractUpsertSuccess = createAction(
        '[Dealer API] Update contract success',
        props <{ contract: Contract, objectSource: ObjectSource}> ()
    );

    public static contractDeleteSubmit = createAction(
        '[Component] Delete contract submit',
        props <{ contractId: string, objectSource: ObjectSource }> ()
    );

    public static contractDeleteSuccess = createAction(
        '[Dealer API] Delete contract success',
        props <{ contractId: string, objectSource: ObjectSource }> ()
    );

    public static contractFetchAllMySubmit = createAction(
        '[Component] Fetch my contracts submit'
    );

    public static contractFetchAllMySuccess = createAction(
        '[Component] Fetch my contracts success',
        props <{ contracts: Contract[] }> ()
    );
    
    // contract modification request

    public static contractModificationNewSubmit = createAction(
        '[Component] Contract modif submit',
        props <{ contractId: string, request: ContractModification, objectSource: ObjectSource  }> ()
    );

    // public static contractModificationNewSuccess = createAction(
    //     '[Dealer API] Contract modif request success',
    //     props <{ contract: Contract }> ()
    // );

    public static contractModificationUpdateSubmit = createAction(
        '[Component] Contract modif update submit',
        props <{ contractId: string, request: ContractModification, objectSource: ObjectSource  }> ()
    );

    public static contractModificationWithdrawSubmit = createAction(
        '[Component] Contract modif withdraw submit',
        props <{ contractId: string, modificationId: number, objectSource: ObjectSource }> ()
    );

    // public static contractModificationUpdateSuccess = createAction(
    //     '[Dealer API] Contract modif request update success',
    //     props <{ contract: Contract }> ()
    // );

    public static contractModificationAnwerSubmit = createAction(
        '[Component] Contract modif answer submit',
        props <{ contractId: string, modificationId: number, accepted: boolean, objectSource: ObjectSource }> ()
    );

    // public static contractModificationAnswerSuccess = createAction(
    //     '[Dealer API] Contract modif request answer success',
    //     props <{ contract: Contract }> ()
    // );


    // Menu data

    public static menuFetchSubmit = createAction(
        '[Component] Fetch my menu submit',
        props <{ codes: MenuCode[], objectSource?: ObjectSource }> ()
    );

    public static menuFetchSuccess = createAction(
        '[Component] Fetch my menu success',
        props <{ menu: { [key: string]: number }}> ()
    );

    //error
    public static dealerFetchError = createAction(
        '[Dealer API Error] Dealer fetch Error',
        props <{ errorMessage: string }> ()
    );

    public static doNothing = createAction(
        '[Dealer API Error] Dealer do nothing'
    );
}